
import blue from '@material-ui/core/colors/blue';
import orange from '@material-ui/core/colors/orange';

const rowStyleChargement = (record, index, defaultStyle = {}) => {
    if (record && record.chge_user_id === 0 )
        return {
            ...defaultStyle,
            borderLeftColor: blue[500],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };
  

        if (record && record.chge_user_id !== 0)
        return {
            ...defaultStyle,
            borderLeftColor: orange[500],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };

        


     
    return defaultStyle;

};

export default rowStyleChargement;